/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArticleDto
 */
export interface ArticleDto {
    /**
     * 
     * @type {any}
     * @memberof ArticleDto
     */
    id?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    ingress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    icon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    descriptionHtml?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    category?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleDto
     */
    hideTableOfContents?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    seoTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    seoDescription?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ArticleDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ArticleDto
     */
    changed?: Date;
}

/**
 * Check if a given object implements the ArticleDto interface.
 */
export function instanceOfArticleDto(value: object): value is ArticleDto {
    return true;
}

export function ArticleDtoFromJSON(json: any): ArticleDto {
    return ArticleDtoFromJSONTyped(json, false);
}

export function ArticleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'title': json['title'] === undefined ? undefined : json['title'] === null ? null : json['title'],
        'ingress': json['ingress'] === undefined ? undefined : json['ingress'] === null ? null : json['ingress'],
        'icon': json['icon'] === undefined ? undefined : json['icon'] === null ? null : json['icon'],
        'descriptionHtml': json['descriptionHtml'] === undefined ? undefined : json['descriptionHtml'] === null ? null : json['descriptionHtml'],
        'category': json['category'] === undefined ? undefined : json['category'] === null ? null : json['category'],
        'hideTableOfContents': json['hideTableOfContents'] == null ? undefined : json['hideTableOfContents'],
        'seoTitle': json['seoTitle'] === undefined ? undefined : json['seoTitle'] === null ? null : json['seoTitle'],
        'seoDescription': json['seoDescription'] === undefined ? undefined : json['seoDescription'] === null ? null : json['seoDescription'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
    };
}

export function ArticleDtoToJSON(json: any): ArticleDto {
    return ArticleDtoToJSONTyped(json, false);
}

export function ArticleDtoToJSONTyped(value?: ArticleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'name': value['name'],
        'title': value['title'],
        'ingress': value['ingress'],
        'icon': value['icon'],
        'descriptionHtml': value['descriptionHtml'],
        'category': value['category'],
        'hideTableOfContents': value['hideTableOfContents'],
        'seoTitle': value['seoTitle'],
        'seoDescription': value['seoDescription'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'changed': value['changed'] == null ? value['changed'] : value['changed'].toISOString(),
    };
}

